import { ListChecks } from 'lucide-react';

import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';

const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'categories',
    label: 'Categories',
    description: 'The kinds of separation, the documents each one needs, and who reviews each document.',
    icon: ListChecks,
    to: '/attrition/settings/categories',
    permission: 'attrition-categories.read',
  },
];

/**
 * Attrition → Settings: a menu of what the module configures. A row added here owes its key to
 * the route's `anyOf` and the sidebar entry's `anyPermission` in the same change.
 */
export function AttritionSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Human Resources', 'Attrition', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-y-auto overflow-x-hidden p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          <p className="text-xs text-slate-500">
            What an attrition request draws on. Every request is filed under a category and asks for that
            category&apos;s documents, so a category needs at least one document on its checklist before a request can
            be filed under it.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
